export { default } from "./NotFound";



// WEBPACK FOOTER //
// ./src/screens/NotFound/index.ts